import {
  ADD_CAMPAIGN_DIRECTION_TYPES,
  DELETE_CAMPAIGN_DIRECTION_TYPES,
  GET_CAMPAIGN_DIRECTION_TYPE_PROFILE,
  GET_CAMPAIGN_DIRECTION_TYPES_LIST,
  HIDE_CAMPAIGN_DIRECTION_TYPES_LOADER,
  SET_CAMPAIGN_DIRECTION_TYPE_PROFILE,
  SET_CAMPAIGN_DIRECTION_TYPES_LIST,
  SET_ERROR_CAMPAIGN_DIRECTION_TYPE_PROFILE,
  SHOW_CAMPAIGN_DIRECTION_TYPES_LOADER,
  UPDATE_CAMPAIGN_DIRECTION_TYPE_PROFILE
} from "./actionTypes";

export const getCampaignDirectionTypesList = data => ({
  type: GET_CAMPAIGN_DIRECTION_TYPES_LIST,
  payload: data
})

export const setCampaignDirectionTypesList = payload => ({
  type: SET_CAMPAIGN_DIRECTION_TYPES_LIST,
  payload
})

export const showCampaignDirectionTypesListLoader = () => ({
  type: SHOW_CAMPAIGN_DIRECTION_TYPES_LOADER
})

export const hideCampaignDirectionTypesListLoader = () => ({
  type: HIDE_CAMPAIGN_DIRECTION_TYPES_LOADER
})

export const addCampaignDirectionType = (directionType = {}, data = {}) => ({
  type: ADD_CAMPAIGN_DIRECTION_TYPES,
  payload: { directionType, data }
});

export const deleteCampaignDirectionType = (id, data = {}) => ({
  type: DELETE_CAMPAIGN_DIRECTION_TYPES,
  payload: { id, data }
});

export const getCampaignDirectionTypeProfile = id => ({
  type: GET_CAMPAIGN_DIRECTION_TYPE_PROFILE,
  payload: id
})

export const setCampaignDirectionTypeProfile = payload => ({
  type: SET_CAMPAIGN_DIRECTION_TYPE_PROFILE,
  payload
})

export const updateCampaignDirectionTypeProfile = (id, directionType = {}, data = {}) => ({
  type: UPDATE_CAMPAIGN_DIRECTION_TYPE_PROFILE,
  payload: {id, directionType, data }
})

export const setErrorCampaignDirectionTypeProfile = payload => ({
  type: SET_ERROR_CAMPAIGN_DIRECTION_TYPE_PROFILE,
  payload
})